import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { actionCreators } from '../../actions';
import Alert from '../../../../../../components/Alert/Alert';
import Form from './components/Form';
import submitForm from '../../components/submitForm';
import s from './Recipient.module.sass';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Recipient = ({ previous }) => {
  const { t } = useTranslation('upload');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const { handleSubmit, watch, setError, formState: { errors, isSubmitting } } = useFormContext();
  
  const customerUpload = useSelector(state => state.customerUpload);
  const { hasError, apiError, recipients, isFetching, hasRecipients } = customerUpload;
  
  const hasSpecificRecipient = watch('specificRecipient');

  useEffect(() => {
    dispatch(actionCreators.clearRecipientsError());
  }, []);

  useEffect(() => {
    if (hasSpecificRecipient) {
      dispatch(actionCreators.clearRecipientsError());
      dispatch(actionCreators.getRecipients());
    }
  }, [dispatch, hasSpecificRecipient]);

  useEffect(() => {
    if (hasError && apiError?.status === 403) {
      const returnUrl = encodeURIComponent(location.pathname);
      navigate(`/mfa?returnUrl=${returnUrl}`);
    }
  }, [hasError, apiError, navigate, location.pathname]);

  const onSubmit = async (data) => {
    try {
      await submitForm(data, navigate, setError);
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <>
      <Form 
        s={s}
        handleSubmit={handleSubmit(onSubmit)}
        previous={previous}
        hasError={hasError}
        recipients={recipients}
        isFetching={isFetching}
        hasRecipients={hasRecipients}
        hasSpecificRecipient={hasSpecificRecipient}
        isSubmitting={isSubmitting}
        errors={errors}
      />
      <Alert 
        className="alert alert--danger" 
        isVisible={Object.keys(errors).length > 0}
      >
        {errors.root?.message || errors.fileDrop?.message || errors.recipient?.message}
      </Alert>
    </>
  );
};

export default Recipient;
